
enum Percentage {
    UNKNOWN = -1,
    ZERO = 0,
    FIFTY = 1,
    HUNDRED = 2
}

export default Percentage;